import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import TopHeader from '../../template/TopHeader';
import MarketingTopNav from '../MarketingTopNav';
import BrandPage from '../../marketing-v2/features/brand/BrandPage';
import { CONFIG_PAGE } from '../../marketing-v2/features/brand/brandPreview';
import { EMAIL_TEMPLATES_V2_VISIBLE } from '../../../config/featureFlags';
import { goUp } from '../goUp';

const CONFIG = { path: CONFIG_PAGE, label: 'Config' };

/**
 * Marketing › Config › Your brand: the brand on a page of its own, below
 * Config. Back (and Done) go up to the page that opened it, or Config.
 */
function MarketingBrand(props) {
  if (!EMAIL_TEMPLATES_V2_VISIBLE) return <Redirect to={CONFIG_PAGE} />;
  return (
    <div className="h_n catalogue-no-header">
      <div className="body_container cm_bg_white">
        <TopHeader title="" {...props} />
        <div className="catalogue-page-wrapper">
          <MarketingTopNav activeTab="settings" parent={CONFIG} title="Your brand" />
          <div className="catalogue-content-container">
            <BrandPage onDone={() => goUp(props.history, props.location, CONFIG.path)} />
          </div>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return { user: state.user };
}

export default connect(mapStateToProps)(MarketingBrand);
